// Build identifiers injected at build time by vite.config.ts.
// Surfaced as a <meta name="finplay-build"> tag so reviewers and the
// in-app version poller can verify which build is loaded.

export const BUILD_ID: string =
  typeof __BUILD_ID__ !== "undefined" ? __BUILD_ID__ : "unknown";
export const BUILD_TIME: string =
  typeof __BUILD_TIME__ !== "undefined" ? __BUILD_TIME__ : "unknown";

let metaInstalled = false;

export const installBuildMeta = () => {
  if (metaInstalled || typeof document === "undefined") return;
  metaInstalled = true;

  const set = (name: string, content: string) => {
    let el = document.head.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute("name", name);
      document.head.appendChild(el);
    }
    el.setAttribute("content", content);
  };

  set("finplay-build", BUILD_ID);
  set("finplay-build-time", BUILD_TIME);
};
